import { useIsWellSaidAdmin } from 'context/user/UserContext';
import { isLegacyProjectViewOnly } from './legacyProjectRetirement';

/**
 * True when a classic legacy project is in retirement view-only mode
 * (on/after July 30, 2026). WellSaid admins are never view-only.
 */
export default function useIsLegacyProjectViewOnly(
  studioVersion: string | null | undefined
): boolean {
  const isWellSaidAdmin = useIsWellSaidAdmin();
  if (isWellSaidAdmin) {
    return false;
  }

  return isLegacyProjectViewOnly({
    studioVersion,
  });
}
